import type { SVGProps } from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgApplePay = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 39.312" aria-labelledby={titleId} {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M30.978 13.404c-.228.177-4.253 2.445-4.253 7.488 0 5.833 5.122 7.897 5.275 7.948-.024.126-.814 2.826-2.7 5.578-1.683 2.421-3.44 4.839-6.113 4.839-2.673 0-3.36-1.553-6.446-1.553-3.007 0-4.076 1.604-6.521 1.604-2.445 0-4.151-2.24-6.112-4.992C1.836 31.085 0 26.066 0 21.3 0 13.66 4.968 9.607 9.858 9.607c2.598 0 4.764 1.706 6.396 1.706 1.552 0 3.973-1.808 6.93-1.808 1.12 0 5.145.102 7.794 3.9zM21.78 6.27c1.223-1.45 2.087-3.463 2.087-5.476 0-.279-.023-.562-.074-.79-1.99.075-4.356 1.325-5.782 2.98-1.12 1.273-2.166 3.286-2.166 5.326 0 .307.05.613.074.711.126.024.33.052.535.052 1.785 0 4.029-1.195 5.326-2.803z"
    />
  </svg>
);

export default SvgApplePay;
